import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputField from './input-field';
import ErrorMessage from './display-error';
import { checkContainer } from '../general-functions';
import NextButton from './next-button';
import '../global';

class UserInformation extends Component {

	render() {
		const sectionName = 'user-information';
		const active = checkContainer( sectionName, this.props.currentPage );
		const error = this.props.passwordError;
		let errorContent = '';
		if ( error !== '' ) {
			errorContent = (<ErrorMessage message={ error } />
			);
		}
		return (
			<div className={ `preferences-section ${active}` } id={ sectionName }>
				<legend className="ajaxForm">Personal Information</legend>
				<div className="form-group ajaxForm ">
					{ errorContent }
					<InputField type="email" id="email" name="Email" disabled="disabled" placeholder={ getEmail() } />
					<InputField type="password" id="new_password" name="New Password" helpText={ 'Minimum of 7 characters long with at least 1 letter and 1 number.' } />
					<InputField type="password" id="confirm_password" name="Confirm Password" />
					<NextButton gtm_class={ 'password' } info={ this.props.userInfo } />
				</div>
			</div>
		);

	}

}

function mapStateToProps( { currentPage, userInfo, passwordError } ) {
	return {
		currentPage, userInfo, passwordError
	};
}

export default connect( mapStateToProps )( UserInformation );